import axios from "axios";
import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import baseURL from "../../../../configs/api";
import { Button } from "@mui/material";
import axois from "../../../../configs/axois";
import { useTheme } from "../../../../components/hooks/useTheme";
import PleaseWaitPopup from "../../../PleaseWaitPopup";
import colorConfigs from "../../../../configs/colorConfigs";
import useAuth from "../../../../components/hooks/useAuth";
import Cookies from "js-cookie";
import useTenant from "../../../../components/hooks/useTenant";

const modules = {
  toolbar: [
    [{ font: [] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    ["blockquote", "code-block"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }, { align: [] }],
    ["link", "image", "video"],
    ["clean"],
  ],
};

export default function ReturnTemplates() {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { auth }: any = useAuth();
  const { themeStyles, theme } = useTheme();
  const { handleTenantError }: any = useTenant();
  const [logo, setLogo] = useState<string>("");
  const [logoInput, setLogoInput] = useState<string>("Logo");
  const [logoObj, setLogoObj] = useState<any>();
  const [logoFirst, setLogoFirst] = useState<string>("");
  const [logoFirstInput, setLogoFirstInput] = useState<string>("Title First");
  const [logoFirstObj, setLogoFirstObj] = useState<any>();
  const [logoSecond, setLogoSecond] = useState<string>("");
  const [logoSecondInput, setLogoSecondInput] = useState<string>("Title Second");
  const [logoSecondObj, setLogoSecondObj] = useState<any>();
  const [rentalInformation, setRentalInformation] = useState<string>("");
  const [rentalInformationInput, setRentalInformationInput] =
    useState<string>("Rental Information");
  const [rentalInformationObj, setRentalInformationObj] = useState<any>();
  const [rentalInformationSecond, setRentalInformationSecond] =
    useState<string>("");
  const [rentalInformationSecondInput, setRentalInformationSecondInput] =
    useState<string>("Rental Information");
  const [rentalInformationSecondObj, setRentalInformationSecondObj] =
    useState<any>();
  const [footer, setFooter] = useState<string>("");
  const [footerObj, setFooterObj] = useState<any>();
  const [vehicleInformation, setVehicleInformation] = useState<string>("");
  const [vehicleInformationInput, setVehicleInformationInput] =
    useState<string>("Vehicle Information");
  const [vehicleInformationObj, setVehicleInformationObj] = useState<any>();
  const [chargeInformation, setChargeInformation] = useState<string>("");
  const [chargeInformationInput, setChargeInformationInput] =
    useState<string>("Rental Summary");
  const [chargeInformationObj, setChargeInformationObj] = useState<any>();
  const [signature, setSignature] = useState<string>("");
  const [signatureInput, setSignatureInput] = useState<string>("Signature");
  const [signatureObj, setSignatureObj] = useState<any>();

  const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
  const [getValue, setGetValue] = useState<boolean>(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setPleaseWaitPopup(true);

    if (footerObj) {
      await axios
        .put(
          `${baseURL}returnReceipt?userId=${auth?.id}`,
          JSON.stringify({
            id: footerObj?.id,
            receiptName: "Footer",
            receiptNote: footer,
            createdDate: new Date(),
            createdByUserId: 1,
            updatedDate: new Date(),
            updatedByUserId: 1,
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          handleTenantError(null);
        })
        .catch((error) => {
          handleTenantError(error);
        });
    } else {
      if (rentalInformation || rentalInformationInput) {
        await axios
          .post(
            `${baseURL}returnReceipt?userId=${auth?.id}`,
            JSON.stringify({
              receiptName: "Footer",
              receiptNote: footer,
              createdDate: new Date(),
              createdByUserId: 1,
              updatedDate: new Date(),
              updatedByUserId: 1,
            }),
            {
              headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "application/json"
              },
              withCredentials: true,
            }
          )
          .then(() => {
            handleTenantError(null);
          })
          .catch((error) => {
            handleTenantError(error);
          });
      }
    }

    if (rentalInformationObj) {
      await axios
        .put(
          `${baseURL}returnReceipt?userId=${auth?.id}`,
          JSON.stringify({
            id: rentalInformationObj?.id,
            receiptName: rentalInformationInput,
            receiptNote: rentalInformation,
            createdDate: new Date(),
            createdByUserId: 1,
            updatedDate: new Date(),
            updatedByUserId: 1,
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          handleTenantError(null);
        })
        .catch((error) => {
          handleTenantError(error);
        });
    } else {
      if (rentalInformation || rentalInformationInput) {
        await axios
          .post(
            `${baseURL}returnReceipt?userId=${auth?.id}`,
            JSON.stringify({
              receiptName: rentalInformationInput,
              receiptNote: rentalInformation,
              createdDate: new Date(),
              createdByUserId: 1,
              updatedDate: new Date(),
              updatedByUserId: 1,
            }),
            {
              headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "application/json"
              },
              withCredentials: true,
            }
          )
          .then(() => {
            handleTenantError(null);
          })
          .catch((error) => {
            handleTenantError(error);
          });
      }
    }

    if (rentalInformationSecondObj) {
      await axios
        .put(
          `${baseURL}returnReceipt?userId=${auth?.id}`,
          JSON.stringify({
            id: rentalInformationSecondObj?.id,
            receiptName: rentalInformationSecondInput,
            receiptNote: rentalInformationSecond,
            createdDate: new Date(),
            createdByUserId: 1,
            updatedDate: new Date(),
            updatedByUserId: 1,
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          handleTenantError(null);
        })
        .catch((error) => {
          handleTenantError(error);
        });
    } else {
      if (rentalInformationSecond || rentalInformationSecondInput) {
        await axios
          .post(
            `${baseURL}returnReceipt?userId=${auth?.id}`,
            JSON.stringify({
              receiptName: rentalInformationSecondInput,
              receiptNote: rentalInformationSecond,
              createdDate: new Date(),
              createdByUserId: 1,
              updatedDate: new Date(),
              updatedByUserId: 1,
            }),
            {
              headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "application/json"
              },
              withCredentials: true,
            }
          )
          .then(() => {
            handleTenantError(null);
          })
          .catch((error) => {
            handleTenantError(error);
          });
      }
    }

    if (vehicleInformationObj) {
      await axios
        .put(
          `${baseURL}returnReceipt?userId=${auth?.id}`,
          JSON.stringify({
            id: vehicleInformationObj?.id,
            receiptName: vehicleInformationInput,
            receiptNote: vehicleInformation,
            createdDate: new Date(),
            createdByUserId: 1,
            updatedDate: new Date(),
            updatedByUserId: 1,
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          handleTenantError(null);
        })
        .catch((error) => {
          handleTenantError(error);
        });
    } else {
      if (vehicleInformation || vehicleInformationInput) {
        await axios
          .post(
            `${baseURL}returnReceipt?userId=${auth?.id}`,
            JSON.stringify({
              receiptName: vehicleInformationInput,
              receiptNote: vehicleInformation,
              createdDate: new Date(),
              createdByUserId: 1,
              updatedDate: new Date(),
              updatedByUserId: 1,
            }),
            {
              headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "application/json"
              },
              withCredentials: true,
            }
          )
          .then(() => {
            handleTenantError(null);
          })
          .catch((error) => {
            handleTenantError(error);
          });
      }
    }

    if (chargeInformationObj) {
      await axios
        .put(
          `${baseURL}returnReceipt?userId=${auth?.id}`,
          JSON.stringify({
            id: chargeInformationObj?.id,
            receiptName: chargeInformationInput,
            receiptNote: chargeInformation,
            createdDate: new Date(),
            createdByUserId: 1,
            updatedDate: new Date(),
            updatedByUserId: 1,
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          handleTenantError(null);
        })
        .catch((error) => {
          handleTenantError(error);
        });
    } else {
      if (chargeInformation || chargeInformationInput) {
        await axios
          .post(
            `${baseURL}returnReceipt?userId=${auth?.id}`,
            JSON.stringify({
              receiptName: chargeInformationInput,
              receiptNote: chargeInformation,
              createdDate: new Date(),
              createdByUserId: 1,
              updatedDate: new Date(),
              updatedByUserId: 1,
            }),
            {
              headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "application/json"
              },
              withCredentials: true,
            }
          )
          .then(() => {
            handleTenantError(null);
          })
          .catch((error) => {
            handleTenantError(error);
          });
      }
    }

    if (signatureObj) {
      await axios
        .put(
          `${baseURL}returnReceipt?userId=${auth?.id}`,
          JSON.stringify({
            id: signatureObj?.id,
            receiptName: signatureInput,
            receiptNote: signature,
            createdDate: new Date(),
            createdByUserId: 1,
            updatedDate: new Date(),
            updatedByUserId: 1,
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          handleTenantError(null);
        })
        .catch((error) => {
          handleTenantError(error);
        });
    } else {
      if (signature || signatureInput) {
        await axios
          .post(
            `${baseURL}returnReceipt?userId=${auth?.id}`,
            JSON.stringify({
              receiptName: signatureInput,
              receiptNote: signature,
              createdDate: new Date(),
              createdByUserId: 1,
              updatedDate: new Date(),
              updatedByUserId: 1,
            }),
            {
              headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "application/json"
              },
              withCredentials: true,
            }
          )
          .then(() => {
            handleTenantError(null);
          })
          .catch((error) => {
            handleTenantError(error);
          });
      }
    }

    if (logoObj) {
      await axios
        .put(
          `${baseURL}returnReceipt?userId=${auth?.id}`,
          JSON.stringify({
            id: logoObj?.id,
            receiptName: logoInput,
            receiptNote: logo,
            createdDate: new Date(),
            createdByUserId: 1,
            updatedDate: new Date(),
            updatedByUserId: 1,
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          handleTenantError(null);
        })
        .catch((error) => {
          handleTenantError(error);
        });
    } else {
      if (logo) {
        await axios
          .post(
            `${baseURL}returnReceipt?userId=${auth?.id}`,
            JSON.stringify({
              receiptName: logoInput,
              receiptNote: logo,
              createdDate: new Date(),
              createdByUserId: 1,
              updatedDate: new Date(),
              updatedByUserId: 1,
            }),
            {
              headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "application/json"
              },
              withCredentials: true,
            }
          )
          .then(() => {
            handleTenantError(null);
          })
          .catch((error) => {
           handleTenantError(error);
          });
      }
    }

    if (logoFirstObj) {
      await axios
        .put(
          `${baseURL}returnReceipt?userId=${auth?.id}`,
          JSON.stringify({
            id: logoFirstObj?.id,
            receiptName: logoFirstInput,
            receiptNote: logoFirst,
            createdDate: new Date(),
            createdByUserId: 1,
            updatedDate: new Date(),
            updatedByUserId: 1,
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          handleTenantError(null);
        })
        .catch((error) => {
          handleTenantError(error);
        });
    } else {
      if (logoFirst) {
        await axios
          .post(
            `${baseURL}returnReceipt?userId=${auth?.id}`,
            JSON.stringify({
              receiptName: logoFirstInput,
              receiptNote: logoFirst,
              createdDate: new Date(),
              createdByUserId: 1,
              updatedDate: new Date(),
              updatedByUserId: 1,
            }),
            {
              headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "application/json"
              },
              withCredentials: true,
            }
          )
          .then(() => {
            handleTenantError(null);
          })
          .catch((error) => {
            handleTenantError(error);
          });
      }
    }

    if (logoSecondObj) {
      await axios
        .put(
          `${baseURL}returnReceipt?userId=${auth?.id}`,
          JSON.stringify({
            id: logoSecondObj?.id,
            receiptName: logoSecondInput,
            receiptNote: logoSecond,
            createdDate: new Date(),
            createdByUserId: 1,
            updatedDate: new Date(),
            updatedByUserId: 1,
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          setPleaseWaitPopup(false);
          handleTenantError(null);
        })
        .catch((error) => {
          handleTenantError(error);
        });
    } else {
      if (logoSecond) {
        await axios
          .post(
            `${baseURL}returnReceipt?userId=${auth?.id}`,
            JSON.stringify({
              receiptName: logoSecondInput,
              receiptNote: logoSecond,
              createdDate: new Date(),
              createdByUserId: 1,
              updatedDate: new Date(),
              updatedByUserId: 1,
            }),
            {
              headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "application/json"
              },
              withCredentials: true,
            }
          )
          .then(() => {
            setPleaseWaitPopup(false);
            handleTenantError(null);
          })
          .catch((error) => {
            handleTenantError(error);
          });
      }
    }

  };

  useEffect(() => {
    setPleaseWaitPopup(true);

    axois
      .get(`${baseURL}returnReceipt`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setRentalInformationObj(
          () =>
            response.data.filter(
              (item: any) =>
                item.receiptName !== "Footer"
            )[7]
        );
        setRentalInformationSecondObj(
          () =>
            response.data.filter(
              (item: any) =>
                item.receiptName !== "Footer"
            )[6]
        );
        setVehicleInformationObj(
          () =>
            response.data.filter(
              (item: any) =>
                item.receiptName !== "Footer"
            )[5]
        );
        setChargeInformationObj(
          () =>
            response.data.filter(
              (item: any) =>
                item.receiptName !== "Footer"
            )[4]
        );
        setSignatureObj(
          () =>
            response.data.filter(
              (item: any) =>
                item.receiptName !== "Footer"
            )[3]
        );
        setLogoObj(() =>
          response.data.filter(
            (item: any) =>
              item.receiptName !== "Footer"
          )[2])
        setLogoFirstObj(() =>
          response.data.filter(
            (item: any) =>
              item.receiptName !== "Footer"
          )[1])
        setLogoSecondObj(() =>
          response.data.filter(
            (item: any) =>
              item.receiptName !== "Footer"
          )[0]
        );
        setFooterObj(() =>
          response.data.find((item: any) => item.receiptName === "Footer")
        );

        setGetValue(true);
        handleTenantError(null);
      })
      .catch((error) => {
        console.error(error);
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (pleaseWaitPopup && getValue) {
      setLogo(() => logoObj?.receiptNote);
      setLogoInput(() => logoObj?.receiptName)
      setLogoFirst(() => logoFirstObj?.receiptNote);
      setLogoFirstInput(() => logoFirstObj?.receiptName);
      setLogoSecond(() => logoSecondObj?.receiptNote);
      setLogoSecondInput(() => logoSecondObj?.receiptName)
      setRentalInformation(() => rentalInformationObj?.receiptNote);
      setRentalInformationInput(() => rentalInformationObj?.receiptName);
      setRentalInformationSecond(
        () => rentalInformationSecondObj?.receiptNote
      );
      setRentalInformationSecondInput(
        () => rentalInformationSecondObj?.receiptName
      );
      setFooter(() => footerObj?.receiptNote);
      setVehicleInformation(() => vehicleInformationObj?.receiptNote);
      setVehicleInformationInput(() => vehicleInformationObj?.receiptName);
      setChargeInformation(() => chargeInformationObj?.receiptNote);
      setChargeInformationInput(() => chargeInformationObj?.receiptName);
      setSignature(() => signatureObj?.receiptNote);
      setSignatureInput(() => signatureObj?.receiptName);

      setPleaseWaitPopup(false);
      setGetValue(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pleaseWaitPopup, getValue]);

  return (
    <>
      <div
        className={`w-full flex flex-row px-[30px] py-[24px] ${themeStyles.main.tailwindSectionBg}`}
      >
        <div className="w-full mr-[3%]">
          <h3
            className={`text-[12px] pb-0 m-0 ${themeStyles.main?.textHeadingColor}`}
          >
            Overview
          </h3>
          <hr />

          <form onSubmit={(e) => handleSubmit(e)}>
            <div
              className={`w-full h-[375px] flex flex-row p-4 gap-4 border border-dashed ${themeStyles.main?.borderColor}`}
            >
              <div className="w-[33%] h-[300px]">
                <input
                  type="text"
                  className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                  value={logoInput}
                  onChange={(e) => setLogoInput(e.target.value)}
                  required
                />

                <div
                  className="quill-wrapper"
                  style={{
                    ...(theme === 'dark' && {
                      '--quill-text-color': '#ffffff',
                      '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                    }),
                  } as React.CSSProperties}
                >
                  <ReactQuill
                    className="custom-quill"
                    style={{ height: "225px" }}
                    theme="snow"
                    modules={modules}
                    defaultValue={logo}
                    value={logo}
                    onChange={setLogo}
                  />
                </div>
              </div>

              <div className="w-[33%] h-[300px]">
                <input
                  type="text"
                  className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                  value={logoFirstInput}
                  onChange={(e) => setLogoFirstInput(e.target.value)}
                  required
                />

                <div
                  className="quill-wrapper"
                  style={{
                    ...(theme === 'dark' && {
                      '--quill-text-color': '#ffffff',
                      '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                    }),
                  } as React.CSSProperties}
                >
                  <ReactQuill
                    className="custom-quill"
                    style={{ height: "225px" }}
                    theme="snow"
                    modules={modules}
                    defaultValue={logoFirst}
                    value={logoFirst}
                    onChange={setLogoFirst}
                  />
                </div>
              </div>

              <div className="w-[33%] h-[300px]">
                <input
                  type="text"
                  className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                  value={logoSecondInput}
                  onChange={(e) => setLogoSecondInput(e.target.value)}
                  required
                />

                <div
                  className="quill-wrapper"
                  style={{
                    ...(theme === 'dark' && {
                      '--quill-text-color': '#ffffff',
                      '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                    }),
                  } as React.CSSProperties}
                >
                  <ReactQuill
                    className="custom-quill"
                    style={{ height: "225px" }}
                    theme="snow"
                    modules={modules}
                    defaultValue={logoSecond}
                    value={logoSecond}
                    onChange={setLogoSecond}
                  />
                </div>
              </div>
            </div>

            <div
              className={`w-full flex flex-row justify-between gap-4 mt-[40px] px-4 pt-4 pb-[80px] border border-black border-dashed ${themeStyles.main.tailwindSectionBg}`}
            >
              <div className="w-1/2">
                <div>
                  <input
                    type="text"
                    className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                    value={rentalInformationInput}
                    onChange={(e) => setRentalInformationInput(e.target.value)}
                    required
                  />

                  <div
                    className="quill-wrapper"
                    style={{
                      ...(theme === 'dark' && {
                        '--quill-text-color': '#ffffff',
                        '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                      }),
                    } as React.CSSProperties}
                  >
                    <ReactQuill
                      className="custom-quill"
                      style={{ height: "225px" }}
                      theme="snow"
                      modules={modules}
                      defaultValue={rentalInformation}
                      value={rentalInformation}
                      onChange={setRentalInformation}
                    />
                  </div>
                </div>

                <div className="mt-[80px]">
                  <input
                    type="text"
                    className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                    value={rentalInformationSecondInput}
                    onChange={(e) => setRentalInformationSecondInput(e.target.value)}
                    required
                  />

                  <div
                    className="quill-wrapper"
                    style={{
                      ...(theme === 'dark' && {
                        '--quill-text-color': '#ffffff',
                        '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                      }),
                    } as React.CSSProperties}
                  >
                    <ReactQuill
                      className="custom-quill"
                      style={{ height: "225px" }}
                      theme="snow"
                      modules={modules}
                      defaultValue={rentalInformationSecond}
                      value={rentalInformationSecond}
                      onChange={setRentalInformationSecond}
                    />
                  </div>
                </div>

                <div className="mt-[80px]">
                  <div
                    className="quill-wrapper"
                    style={{
                      ...(theme === 'dark' && {
                        '--quill-text-color': '#ffffff',
                        '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                      }),
                    } as React.CSSProperties}
                  >
                    <ReactQuill
                      className="custom-quill"
                      style={{ height: "225px" }}
                      theme="snow"
                      modules={modules}
                      defaultValue={footer}
                      value={footer}
                      onChange={setFooter}
                    />
                  </div>
                </div>
              </div>

              <div className="w-1/2">
                <div>
                  <input
                    type="text"
                    className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                    value={chargeInformationInput}
                    onChange={(e) => setChargeInformationInput(e.target.value)}
                    required
                  />

                  <div
                    className="quill-wrapper"
                    style={{
                      ...(theme === 'dark' && {
                        '--quill-text-color': '#ffffff',
                        '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                      }),
                    } as React.CSSProperties}
                  >
                    <ReactQuill
                      className="custom-quill"
                      style={{ height: "225px" }}
                      theme="snow"
                      defaultValue={chargeInformation}
                      value={chargeInformation}
                      modules={modules}
                      onChange={setChargeInformation}
                    />
                  </div>
                </div>

                <div className="mt-[80px]">
                  <input
                    type="text"
                    className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                    value={vehicleInformationInput}
                    onChange={(e) => setVehicleInformationInput(e.target.value)}
                    required
                  />

                  <div
                    className="quill-wrapper"
                    style={{
                      ...(theme === 'dark' && {
                        '--quill-text-color': '#ffffff',
                        '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                      }),
                    } as React.CSSProperties}
                  >
                    <ReactQuill
                      className="custom-quill"
                      style={{ height: "225px" }}
                      theme="snow"
                      defaultValue={vehicleInformation}
                      value={vehicleInformation}
                      modules={modules}
                      onChange={setVehicleInformation}
                    />
                  </div>
                </div>

                <div className="mt-[80px]">
                  <input
                    type="text"
                    className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                    value={signatureInput}
                    onChange={(e) => setSignatureInput(e.target.value)}
                    required
                  />

                  <div
                    className="quill-wrapper"
                    style={{
                      ...(theme === 'dark' && {
                        '--quill-text-color': '#ffffff',
                        '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                      }),
                    } as React.CSSProperties}
                  >
                    <ReactQuill
                      className="custom-quill"
                      style={{ height: "225px" }}
                      theme="snow"
                      defaultValue={signature}
                      value={signature}
                      modules={modules}
                      onChange={setSignature}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-[1.5rem]">
              <Button variant="contained"
                sx={{
                  backgroundColor: colorConfigs.btn.main.bg
                }}
                type="submit"
              >
                Save
              </Button>
            </div>
          </form>
        </div>
      </div>

      <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
    </>
  );
}

